import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  // path: {
  //   fill: '#7df3e1',
  // },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <path d="M397.3639,369.6345l-70.9371-141.8698c-1.1971,9.5974-3.1983,19.1671-6.7826,27.9601-3.1983,8.8045-7.5913,17.1633-12.7311,25.1614l28.6997,57.5327-163.0312-68.3408c-15.9274-6.8033-27.9089-19.1691-34.2885-35.5696-5.9908-16.3998-5.1844-33.9677,2.7937-49.1723l59.0004-118.7101,59.0006,118.3067c7.5891,15.608,8.7839,33.1617,2.7939,49.1737-10.0015,27.3738-33.5062,35.1676-35.0809,35.9717l45.8247,19.1669c12.3681-11.1964,21.9171-25.1614,27.907-40.7715,9.9809-26.7617,8.3817-56.7239-4.3908-82.3338L218.4051,11.6015c-3.1969-7.2059-10.383-11.6015-18.3179-11.6015s-15.1209,4.3956-18.3179,11.6015l-77.3183,155.0282c-12.7303,25.5664-14.329,55.5287-4.3922,82.3354,9.9798,26.7628,30.7026,48.3651,56.9985,59.5339l213.9964,89.9017c2.3918,1.1971,5.1858,1.5991,7.9797,1.5991,5.5855,0,11.1734-2.4056,15.1345-6.3989,5.5878-6.801,6.7826-16.4005,3.196-23.9666Z" fill="#fff" strokeWidth="0"/>
      <path d="M124.3699,313.2989l-59.8069,25.1637,28.7009-57.1283c-5.1842-8.0004-9.5765-16.4028-12.7303-25.1637-3.1969-9.2089-5.5876-18.7648-6.7828-27.9594L2.8121,369.6345c-3.989,7.6097-2.3905,17.1633,3.197,23.1601,3.9891,4.3954,9.5766,6.3989,15.1209,6.3989,2.7939,0,5.5876-.4044,7.9925-1.5992l143.8646-60.3289-24.7117-10.406c-8.3813-3.1983-16.3307-7.9544-23.9055-13.5606Z" fill="#fff" strokeWidth="0"/>

    </svg>
  );
};

export default LogoIcon;
